import React, { useEffect } from 'react';
import MobilePage from '../UiComponents/MobilePage';
import { useLocation } from 'react-router-dom';
import RequestStep from './RequestStep';
import QnA from './QnA';

const Bold = ({ children }) => {
  return <span className='font-bold'>{children}</span>
}

const About = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    // hash: "#features"
    const id = decodeURIComponent(hash.slice(1));
    const el = document.getElementById(id);
    if (!el) return;

    // 렌더 타이밍 이슈 방지 (특히 데이터 로딩 후 섹션이 생기는 경우)
    setTimeout(() => {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 200)

  }, [hash]);

  return <MobilePage>
    <div className='pt-16'>
      <div>
        <img src="https://image.toast.com/aaaaaud/public/images/gpt/c35f60e6-52d9-4c98-b821-398f10a6d3e3.jpg" />
      </div>
      <div className='px-4 mt-4'>
        <div className='mt-12 text-xl font-bold'>
          텔링파파란 무엇인가요?
        </div>
        <div className='mt-2 text-sm/7'>
          텔링파파는 <Bold>AI로 아이가 주인공인 맞춤형 동화</Bold>를 만드는 서비스예요. 가족과 친구들도 함께 등장해서, 세상에 하나뿐인 이야기가 완성됩니다. <br />
          <br />
          동화 속 이미지는 아이와 가족의 사진을 바탕으로 만들어져요. <br />
          등록한 사진은 캐릭터 이미지로 변환된 뒤 <Bold>자동으로 삭제</Bold>되니 안심하셔도 됩니다.<br />
          <br />
          우리가 만들고 싶은 건 단순히 “아이 이름만 들어간 이야기”가 아니고, 우리 가족과 친구들의 이야기로 다시 만들어진 이야기 입니다.<br />
          아이가 읽고 또 읽고, “한 번만 더!”를 외치게 되는 <Bold>정말 재미있는 동화</Bold>를 만드는 것, 그게 바로 텔링파파의 목표입니다.
        </div>
      </div>
      <div className='mt-12'>
        <img src="https://image.toast.com/aaaaaud/public/images/gpt/27fe4ff0-dcf1-4d36-916b-66a617e47da3.png" />
      </div>
      <div className='mt-12'>
        <QnA />
      </div>
      <div className='px-4'>
        <div className='scroll-mt-16' id="request_step">
          <RequestStep />
        </div>
      </div>
      <div className='mt-12'>
        <img src="https://image.toast.com/aaaaaud/public/images/gpt/2a71192a-de19-4f98-8967-5567651495c3.jpg" />
      </div>
    </div>
  </MobilePage >
}

export default About
